import React from "react";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
// react-scroll मधून Link इम्पोर्ट केली
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";

const theme = {
  primary: "#E8540A",
  bg: "#1A0D05",
  bgLight: "#251508",
  border: "#3A2010",
  text: "#FFFFFF",
  textMuted: "#C8A888",
  textDim: "#9A7858",
};

const OmIcon = () => (
  <div style={{
    width: 52, height: 52, borderRadius: "50%",
    background: "linear-gradient(135deg, #E8540A, #FF8C42)",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 24, color: "#fff", fontFamily: "'Noto Serif Devanagari', serif",
    flexShrink: 0, boxShadow: "0 3px 12px rgba(232,84,10,0.4)",
  }}>ॐ</div>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
  </svg>
);
const TwitterIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
  </svg>
);
const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="none" stroke="currentColor" strokeWidth="2"/>
    <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="2"/>
    <circle cx="17.5" cy="6.5" r="1.5"/>
  </svg>
);
const YoutubeIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58zM10 15V9l5.19 3L10 15z"/>
  </svg>
);
const WhatsappIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);
const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15">
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
  </svg>
);
const EmailIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="15" height="15">
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
  </svg>
);

// स्क्रोलिंगसाठी ID असलेले नवं आयटम्स
const quickLinksItems = [
  { label: "मुख्य", to: "home" },
  { label: "आमच्या विषयी", to: "about" },
  { label: "सेवा", to: "services" },
  { label: "संगीत संग्रह", to: "music" },
  { label: "उत्पादने", to: "products" },
  { label: "संपर्क", to: "contact" },
];

const services = ["जैन संगीत संग्रह", "पूजा विधान मार्गदर्शन", "कराओके ट्रॅक", "विधान पुस्तके", "पूजा साहित्य", "मंत्रोच्चार प्रशिक्षण","privacy"];
const socials = [
  { icon: <FacebookIcon />, label: "Facebook" },
  { icon: <TwitterIcon />, label: "Twitter" },
  { icon: <InstagramIcon />, label: "Instagram" },
  { icon: <YoutubeIcon />, label: "YouTube" },
  { icon: <WhatsappIcon />, label: "WhatsApp" },
];

export default function Footer() {
  return (
    <footer style={{ backgroundColor: theme.bg, fontFamily: "'Noto Sans Devanagari', 'Segoe UI', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;600;700&family=Noto+Serif+Devanagari:wght@400;600;700&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }

        .footer-main {
          max-width: 1200px;
          margin: 0 auto;
          padding: 56px 32px 40px;
          display: grid;
          grid-template-columns: 2fr 1fr 1.4fr 1.6fr;
          gap: 48px;
        }

        .brand-row {
          display: flex;
          align-items: center;
          gap: 14px;
          margin-bottom: 14px;
        }

        .brand-name {
          font-family: 'Noto Serif Devanagari', serif;
          font-size: 20px;
          font-weight: 700;
          color: #fff;
          line-height: 1.2;
        }

        .brand-tagline {
          font-size: 12.5px;
          color: ${theme.primary};
          margin-top: 2px;
        }

        .brand-desc {
          font-size: 13.5px;
          color: ${theme.textMuted};
          line-height: 1.75;
          margin-bottom: 22px;
        }

        .social-row {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }

        .social-btn {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          border: 1.5px solid ${theme.border};
          background: transparent;
          display: flex;
          align-items: center;
          justify-content: center;
          color: ${theme.textMuted};
          cursor: pointer;
          transition: all 0.22s ease;
        }

        .social-btn:hover {
          border-color: ${theme.primary};
          color: ${theme.primary};
          background: rgba(232,84,10,0.08);
          transform: translateY(-2px);
        }

        .footer-col-title {
          font-family: 'Noto Serif Devanagari', serif;
          font-size: 16px;
          font-weight: 700;
          color: #fff;
          margin-bottom: 18px;
        }

        .footer-links {
          list-style: none;
          padding: 0;
        }

        .footer-links li {
          margin-bottom: 10px;
        }

        .footer-links li .scroll-link {
          font-size: 14px;
          color: ${theme.textMuted};
          text-decoration: none;
          cursor: pointer;
          transition: color 0.2s ease;
          display: inline-block;
        }

        .footer-links li .scroll-link:hover {
          color: ${theme.primary};
        }

        .contact-item {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          margin-bottom: 16px;
        }

        .contact-icon {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          background: rgba(232,84,10,0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-top: 1px;
          color: ${theme.primary};
        }

        .contact-label {
          font-size: 13px;
          color: ${theme.textMuted};
          margin-bottom: 2px;
        }

        .contact-value {
          font-size: 14.5px;
          font-weight: 700;
          color: #fff;
        }

        .contact-email {
          font-size: 13.5px;
          color: ${theme.textMuted};
          font-weight: 400;
        }

        .admin-login-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-top: 15px;
          padding: 9px 18px;
          background-color: transparent;
          border: 1.5px solid ${theme.primary};
          border-radius: 25px;
          color: ${theme.primary};
          font-size: 13.5px;
          font-weight: 700;
          text-decoration: none;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .admin-login-btn:hover {
          background-color: ${theme.primary};
          color: #fff;
          box-shadow: 0 4px 12px rgba(232,84,10,0.2);
        }

        .footer-divider {
          border: none;
          border-top: 1px solid ${theme.border};
          margin: 0 32px;
        }

        .footer-bottom {
          max-width: 1200px;
          margin: 0 auto;
          padding: 18px 32px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
          flex-wrap: wrap;
        }

        .copyright { font-size: 13px; color: ${theme.textDim}; }
        .made-with { font-size: 13px; color: ${theme.textDim}; }

        @media (max-width: 900px) {
          .footer-main { grid-template-columns: 1fr 1fr; gap: 36px; }
        }
        @media (max-width: 540px) {
          .footer-main { grid-template-columns: 1fr; padding: 40px 20px 28px; gap: 28px; }
          .footer-divider, .footer-bottom { padding: 16px 20px; }
          .footer-bottom { flex-direction: column; text-align: center; }
        }
      `}</style>

      <div className="footer-main">
        {/* Brand Column */}
        <div className="brand-col">
          <div className="brand-row">
            <OmIcon />
            <div>
              <p className="brand-name">स्वरसागरामृत परिवार</p>
              <p className="brand-tagline">दिगंबर जैन संगीत व पूजा विधान</p>
            </div>
          </div>
          <p className="brand-desc">
            ज्ञान, साधना, सेवा आणि श्रद्धा यांचे संगमस्थान. दिगंबर जैन धर्मातील संगीत, पूजा आणि विधान परंपरेचे जतन व प्रसार.
          </p>
          <div className="social-row">
            {socials.map((s, i) => (
              <button key={i} className="social-btn" title={s.label}>{s.icon}</button>
            ))}
          </div>
        </div>

        {/* Quick Links with Smooth Scroll */}
        <div>
          <p className="footer-col-title">द्रुत दुवे</p>
          <ul className="footer-links">
            {quickLinksItems.map((item, i) => (
              <li key={i}>
                <ScrollLink
                  className="scroll-link"
                  to={item.to}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  {item.label}
                </ScrollLink>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <p className="footer-col-title">आमच्या सेवा</p>
          <ul className="footer-links">
           {services.map((s, i) => (
  <li key={i}>
    {s === "privacy" ? (
      <RouterLink 
        to="/privacy-policy" 
        style={{ color: '#C8A888', textDecoration: 'none', fontSize: '14px' }}
        onClick={() => window.scrollTo(0, 0)} // नवीन पेजवर गेल्यावर वरून दिसावे म्हणून
      >
        Privacy Policy
      </RouterLink>
    ) : (
      <span style={{ fontSize: '14px', color: '#C8A888' }}>{s}</span>
    )}
  </li>
))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <p className="footer-col-title">संपर्क माहिती</p>

          <div className="contact-item">
            <div className="contact-icon"><PhoneIcon /></div>
            <div>
              <p className="contact-label">पं. श्री सागर उपाध्ये</p>
              <p className="contact-value">7972970108</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon"><PhoneIcon /></div>
            <div>
              <p className="contact-label">श्री. पियुष उपाध्ये</p>
              <p className="contact-value">84689 33143</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon" style={{ color: theme.primary }}><EmailIcon /></div>
            <div>
              <p className="contact-email">swarsagaramrutparivar@gmail.com</p>
            </div>
          </div>

          <a 
            href="http://admin.swarsagaramrut.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="admin-login-btn"
          >
            <AdminPanelSettingsIcon style={{ fontSize: '18px' }} />
            Admin Login
          </a>
        </div>
      </div>

      <hr className="footer-divider" />

      <div className="footer-bottom">
        <p className="copyright">© 2024 स्वरसागरामृत परिवार. सर्व हक्क राखीव.</p>
        <p className="made-with">
          Designed and developed by Comtranse Technology, Kolhapur.
        </p>
      </div>
    </footer>
  );
}